import Column from '@components/Column';
import Image from '@components/Image';
import Indicator from '@components/Indicator';
import styled from '@emotion/styled';
import { GiftItemType } from '@models/gift';
import { useFlow } from '@stackflow/react';
import { useEffect, useRef, useState } from 'react';
import Slider from 'react-slick';

import img from './img.png';

interface Props {
  type: 'GIFT' | 'BUY';
}

function NewCards({ type }:Props) {
    const cards = [img, img, img, img, img];
    const [index, setIndex] = useState<number>(0);
    const settings = {
        infinite: true,
        slidesToScroll: 1,
        slidesToShow: 1,
        arrows: false,
        dots: false,
        speed: 400,
        swipe: true,
        swipeToSlide: true,
        easing: 'ease-out',
        variableWidth: true,
        centerMode: true,
        centerPadding: '30px',
        afterChange: setIndex,
    };
    const isGift = type === 'GIFT';
    const ref = useRef<Slider>(null);
    const { push } = useFlow();
    useEffect(() => {
        const interval = setInterval(() => {
            ref.current?.slickNext();
        }, 2000);
        return () => {
            clearInterval(interval);
        };
    }, [ref]);

    return (
        <Container align='center'>
            {/*
            <Slider {...settings}
                    ref={ref} >
                {cards.map((card, i) => {
                  const handleClick = () => {
                    if (isGift) {
                      push('GiftOrderActivity', {
                        giftItemId: i.toString(),
                        type: GiftItemType.CASH,
                        qty: 1,
                      });
                    } else {
                      push('PrepaidCardImageActivity', { prepaidCardImageId: 'test' });
                    }
                  };
                  return (
                        <CardWrapper key={i.toString()}>
                            <div onClick={handleClick} >
                                <CardImage src={card}
                                       alt=''
                                       width={184}
                                       height={120} />
                            </div>
                        </CardWrapper>
                  );
                })}
            </Slider>
            <Indicator total={cards.length} current={index}/>
            */}
        </Container>
    );
}

const Container = styled(Column)`
    padding: 0 0 30px;
`;

const CardWrapper = styled.div`
    filter: drop-shadow(0 2.519px 20.155px rgba(0, 0, 0, 0.14));
    margin: 30px 0;
    padding: 0 8px;
    width: 100%;
`;

const CardImage = styled(Image)`
    height: 120px;
    width: 184px;
    object-fit: cover;
`;

export default NewCards;
